'use strict'

const state = () => {
    return {
        news: {},
        page: {
            id: 0,
            blocks: [],
            topNews: [],
            currency: false
        }
    }
}

// getters
const getters = {
    news: function (state) {
        return state.news
    },
    page: function (state) {
        return state.page
    },
    blocks: function (state) {
        return state.page.blocks
    },
    currencies: function (state) {
        return state.page.currency ? state.page.currency : false
    },
    inOtherMedia: function (state) {
        return state.page.additionalInfo ? state.page.additionalInfo['in-other-media'] : state.page.additionalInfo['in-other-media']
    },
    topNews: function (state) {
        return Object.values(state.page.topnews)
    },
    additionalInfo: function (state) {
        return state.page.additionalInfo || state.page.additionalInfo
    },
    alerts: function (state) {
        return state.page.alerts || false
    }/*,
    hasContent: (state) => (idBlock, indexComponent) => {
        return null === state.page.content.find(elem => elem.id === idBlock).components[indexComponent].content;
    }*/
}

// actions
const actions = {

}

// mutations
const mutations = {
    page (state, response) {
        state.news = response.content;
        state.page = response.content.page;
    },
    addBlock (state, response) {
        state.page.blocks.push(response);
    },
    dropBlock (state, response) {
        state.page.blocks.forEach((component, index) => {
            if (response === component.id)
                state.page.blocks.splice(index, 1)
        })
    },
    moveBlock(state, { block, replaceBlock }){
        let blockO, blockR, indexO, indexR, orderO, orderR = 0
        state.page.blocks.forEach((component, index) => {
            if (block === component.id) {
                blockO = component
                indexO = index
                orderO = component.order
            }
            if (replaceBlock === component.id) {
                blockR = component
                indexR = index
                orderR = component.order
            }
        })
        blockO.order = orderR
        blockR.order = orderO
        state.page.blocks[indexO] = blockR
        state.page.blocks[indexR] = blockO
    },
    publishBlock(state, block){
        state.page.blocks.forEach((component, index) => {
            if (block === component.id) {
                component.status = !component.status
            }
        })
    },
    publishPage(state){
        state.page.status = !state.page.status
    },
    
    /*** Old methods ***/
    block (state, response) {
        let blockResponse = response
        if (blockResponse.block && blockResponse.block.length > 0) blockResponse = blockResponse.block[0]
        if (!blockResponse) return false
        
        state.page.content.forEach((block, index) => {
            if (block.id === blockResponse.id) {
                state.page.blocks[index] = blockResponse
            }
        })
    },
    
    reorder (state) {
        state.page.content = state.page.content.sort((a, b) => {
            return a.order < b.order ? -1 : 1
        })
        state.page.content.forEach((item, index) => {
            state.page.content[index].order = index + 1
        })
    },
    currencies (state, response) {
        if (response && 0 < Object.entries(response).length){
            state.page.currency = response

        }
    },
    content (state, { response, idBlock, idComponent }) {
        state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).content = response;
    },
    status (state, { idBlock, idComponent }){
        state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).status = !state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).status
    },
    unpublishAllInstances (state, {idBlock, idComponent}){
        state.page.content.find(elem => elem.id === idBlock).components.forEach(elem => {
            if(elem.id === idComponent)
                elem.status = 1
            else
                elem.status = 0
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}